import { render, staticRenderFns } from "./IdTypes.vue?vue&type=template&id=c0c0a932&scoped=true&"
import script from "./IdTypes.vue?vue&type=script&lang=js&"
export * from "./IdTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c0a932",
  null
  
)

export default component.exports